import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Claim -3 Bill Information")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Contract", -1)
const _hoisted_15 = { class: "col-md-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Bill", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "col-md-2 mt-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "d-flex pt-4 pb-2"
}
const _hoisted_21 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_22 = { class: "fw-bold" }
const _hoisted_23 = { class: "fs-6 text-gray-600" }
const _hoisted_24 = { class: "mt-2" }
const _hoisted_25 = { class: "text-info" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("b", { class: "text-black" }, "Note:", -1)
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-8 text-left my-auto" }
const _hoisted_30 = { class: "col-md-4 text-end pr-4 mb-3" }
const _hoisted_31 = ["data-kt-indicator"]
const _hoisted_32 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_33 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_34 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_36 = { class: "card mb-5 mb-xl-10 mt-4" }
const _hoisted_37 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_38 = { class: "collapse show" }
const _hoisted_39 = { class: "card-body border-top p-6" }
const _hoisted_40 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_41 = { class: "table-responsive mt-5" }
const _hoisted_42 = { class: "table table-borderless gy-4" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"25%"} }, "Training Institutes"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"18%"} }, "Course"),
    /*#__PURE__*/_createElementVNode("th", null, "BN"),
    /*#__PURE__*/_createElementVNode("th", null, "Enroll# (A)"),
    /*#__PURE__*/_createElementVNode("th", null, "Enroll Fee %"),
    /*#__PURE__*/_createElementVNode("th", null, "Course Fee (B)"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Bill (C=A*B)"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim 1 (D)"),
    /*#__PURE__*/_createElementVNode("th", null, "Cer# (E)"),
    /*#__PURE__*/_createElementVNode("th", null, "Net Bill (F=B*E)"),
    /*#__PURE__*/_createElementVNode("th", null, "Cer Fee % (CF)"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim 2 (G= F % (CF))"),
    /*#__PURE__*/_createElementVNode("th", null, "Job# (J)"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim-3# (H)"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim 3 (I=B*H-(D+G))"),
    /*#__PURE__*/_createElementVNode("th", null, "Bill Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Bill No"),
    /*#__PURE__*/_createElementVNode("th", null, "Start Date"),
    /*#__PURE__*/_createElementVNode("th", null, "End Date")
  ])
], -1)
const _hoisted_44 = { style: {} }
const _hoisted_45 = { class: "align-middle" }
const _hoisted_46 = { class: "align-middle" }
const _hoisted_47 = { class: "align-middle" }
const _hoisted_48 = { class: "align-middle" }
const _hoisted_49 = { class: "align-middle" }
const _hoisted_50 = { class: "align-middle" }
const _hoisted_51 = { class: "align-middle" }
const _hoisted_52 = { class: "align-middle" }
const _hoisted_53 = { class: "align-middle" }
const _hoisted_54 = { class: "align-middle" }
const _hoisted_55 = { class: "align-middle" }
const _hoisted_56 = { class: "align-middle" }
const _hoisted_57 = { class: "align-middle" }
const _hoisted_58 = { class: "align-middle" }
const _hoisted_59 = { class: "align-middle" }
const _hoisted_60 = { class: "align-middle" }
const _hoisted_61 = { class: "align-middle" }
const _hoisted_62 = { class: "align-middle" }
const _hoisted_63 = { class: "align-middle" }
const _hoisted_64 = { class: "align-middle" }
const _hoisted_65 = { style: {"border-bottom":"1px solid\r\n                                    rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "3",
  class: "font-weight-bold text-black"
}, " Total ", -1)
const _hoisted_67 = { class: "font-weight-bold text-black" }
const _hoisted_68 = { class: "font-weight-bold text-black" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("th", { colspan: "4" }, null, -1)
const _hoisted_70 = { class: "font-weight-bold text-black" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("th", { colspan: "3" }, null, -1)
const _hoisted_72 = { class: "font-weight-bold text-black" }
const _hoisted_73 = { class: "font-weight-bold text-black" }
const _hoisted_74 = { class: "font-weight-bold text-black" }
const _hoisted_75 = { style: {"border-bottom":"1px solid\r\n                                    rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "14",
  class: "font-weight-bold text-black text-end"
}, " A) Gross Amount ", -1)
const _hoisted_77 = { class: "font-weight-bold text-black" }
const _hoisted_78 = { style: {"border-bottom":"1px solid\r\n                                    rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "14",
  class: "font-weight-bold text-black text-end"
}, " B) IA'S Contribution ", -1)
const _hoisted_80 = { class: "font-weight-bold text-black" }
const _hoisted_81 = { style: {"border-bottom":"1px solid\r\n                                    rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "14",
  class: "font-weight-bold text-black text-end"
}, " C) Contribution Amount (A*B) ", -1)
const _hoisted_83 = { class: "font-weight-bold text-black" }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "14",
  class: "font-weight-bold text-black text-end"
}, " D) Bill Amount (A - C) ", -1)
const _hoisted_87 = { class: "font-weight-bold text-black" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "14",
  class: "font-weight-bold text-black text-end"
}, " E) Adjustment of Mobilization Advance (D * 40%) ", -1)
const _hoisted_89 = { class: "font-weight-bold text-black" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "14",
  class: "font-weight-bold text-black text-end"
}, " F) Net Payable (D - E) ", -1)
const _hoisted_91 = { class: "font-weight-bold text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Tranche",
                  modelValue: _ctx.bill.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bill.tranche_id) = $event)),
                  style: {"width":"100%"},
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTrance()))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: trans.id,
                        label: trans.label,
                        value: trans.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(trans.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Partner",
                  modelValue: _ctx.bill.entity_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bill.entity_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getEntityContract()))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (data) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: data.id,
                        label: data.entity_short_name,
                        value: data.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("[" + _toDisplayString(data.entity_short_name) + "]-" + _toDisplayString(data.entity_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Contract",
                  modelValue: _ctx.bill.entity_contract_id,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bill.entity_contract_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getAllBillNo()))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractInfos, (data) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: data.id,
                        label: data.contract_name,
                        value: data.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.contract_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _hoisted_17,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Bill",
                  modelValue: _ctx.bill.bill_no,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bill.bill_no) = $event)),
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allBillNo, (bl) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: bl.bill_sequence_no,
                        label: bl.bill_no,
                        value: bl.bill_sequence_no
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(bl.bill_no), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getBillList())),
                  type: "button",
                  class: "btn btn-success mt-4 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_19
                ])
              ])
            ]),
            (_ctx.showBillList == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("p", _hoisted_25, [
                            _hoisted_26,
                            _createTextVNode(" " + _toDisplayString(_ctx.status), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showBillList == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("h4", _hoisted_29, " Claim-3 Bill Detail (Total Batch Found : " + _toDisplayString(_ctx.billList.length) + ") ", 1),
                    _createElementVNode("span", _hoisted_30, [
                      _createElementVNode("button", {
                        "data-kt-indicator": _ctx.loading ? 'on' : null,
                        class: "btn btn-sm btn-dark ml-3 p-3 text-end",
                        title: "Invoice",
                        style: {"padding-top":"8px !important","padding-bottom":"8px !important"},
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadPdf()))
                      }, [
                        (!_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                              _createTextVNode(" Invoice "),
                              _createElementVNode("span", _hoisted_33, [
                                _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                              _createTextVNode(" Please wait... "),
                              _hoisted_35
                            ]))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_31)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("table", _hoisted_42, [
                                _hoisted_43,
                                _createElementVNode("tbody", _hoisted_44, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billList, (data, index) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: index,
                                      style: {"border-bottom":"1px solid\r\n                                      rgba(29, 182, 140, 0.51) !important"}
                                    }, [
                                      _createElementVNode("td", _hoisted_45, _toDisplayString(index + 1), 1),
                                      _createElementVNode("td", _hoisted_46, _toDisplayString(data?.institute_info?.institute_name) + " ( " + _toDisplayString(data?.institute_info?.short_name) + " ) ", 1),
                                      _createElementVNode("td", _hoisted_47, _toDisplayString(data?.course_info?.course_name) + " | " + _toDisplayString(data?.course_info?.month) + " | " + _toDisplayString(data?.course_info?.hour) + " | " + _toDisplayString(data?.course_info?.unit_cost_total), 1),
                                      _createElementVNode("td", _hoisted_48, _toDisplayString(data?.batch_info?.batch_sequence_number), 1),
                                      _createElementVNode("td", _hoisted_49, _toDisplayString(data?.enroll_count), 1),
                                      _createElementVNode("td", _hoisted_50, _toDisplayString(data?.e_pay_percentage), 1),
                                      _createElementVNode("td", _hoisted_51, _toDisplayString(data?.unit_cost.toFixed(2)), 1),
                                      _createElementVNode("td", _hoisted_52, _toDisplayString(Number(data?.total_bill_amount).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_53, _toDisplayString(Number(data?.e_bill_amount).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_54, _toDisplayString(data?.certification_count), 1),
                                      _createElementVNode("td", _hoisted_55, _toDisplayString(Number(data?.net_bill).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_56, _toDisplayString(data?.c_pay_percentage), 1),
                                      _createElementVNode("td", _hoisted_57, _toDisplayString(Number(data?.cer_bill_amount).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_58, _toDisplayString(data?.placement_count), 1),
                                      _createElementVNode("td", _hoisted_59, _toDisplayString(data?.claim_3_count), 1),
                                      _createElementVNode("td", _hoisted_60, _toDisplayString(Number( data?.bill_amount).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_61, _toDisplayString(data?.bill_date), 1),
                                      _createElementVNode("td", _hoisted_62, _toDisplayString(data?.bill_no), 1),
                                      _createElementVNode("td", _hoisted_63, _toDisplayString(data?.batch_info?.start_date), 1),
                                      _createElementVNode("td", _hoisted_64, _toDisplayString(data?.batch_info?.end_date), 1)
                                    ]))
                                  }), 128))
                                ]),
                                _createElementVNode("tfoot", null, [
                                  _createElementVNode("tr", _hoisted_65, [
                                    _hoisted_66,
                                    _createElementVNode("th", _hoisted_67, _toDisplayString(_ctx.billList.length), 1),
                                    _createElementVNode("th", _hoisted_68, _toDisplayString(Number(this.tolatEnroll).toLocaleString()), 1),
                                    _hoisted_69,
                                    _createElementVNode("th", _hoisted_70, _toDisplayString(Number(this.tolatCertified).toLocaleString()), 1),
                                    _hoisted_71,
                                    _createElementVNode("th", _hoisted_72, _toDisplayString(Number(this.tolatJob).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_73, _toDisplayString(Number(this.totalClaim3).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_74, _toDisplayString(Number(
                                      this.tolatBillAmount
                                    ).toLocaleString()), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_75, [
                                    _hoisted_76,
                                    _createElementVNode("th", _hoisted_77, _toDisplayString(Number(
                                      this.tolatBillAmount
                                    ).toLocaleString()), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_78, [
                                    _hoisted_79,
                                    _createElementVNode("th", _hoisted_80, _toDisplayString(Number(
                                      this.contributionPay
                                    ).toLocaleString()) + "% ", 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_81, [
                                    _hoisted_82,
                                    _createElementVNode("th", _hoisted_83, [
                                      (this.totalContributionAmount)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(Number(
                                        this.totalContributionAmount
                                      ).toLocaleString()), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_85, "0.00"))
                                    ])
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_86,
                                    _createElementVNode("th", _hoisted_87, _toDisplayString(this.totalBillAfterContribution.toFixed(2)), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_88,
                                    _createElementVNode("th", _hoisted_89, _toDisplayString(this.totalContributionAdj.toFixed(2)), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _hoisted_90,
                                    _createElementVNode("th", _hoisted_91, _toDisplayString(this.totalPayableAmount.toFixed(2)), 1)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}